<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col md="6">
            <select-place :items="cities" multiple chips></select-place>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6">
            <select-state-city @change="changeStateCity"></select-state-city>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import SelectPlace from "@/components/dashboard/inputs/SelectPlace.vue";
import SelectStateCity from "@/components/dashboard/inputs/SelectStateCity.vue";
export default {
  data() {
    return {
      view: "dashboard",
      datacollection: null,
      cities: [
        "Bogotá",
        "Medellín",
        "Cali",
        "Pereira",
        "Norde de Santander",
        "Magdalena",
        "Atlantico",
        "Amazonas",
      ],
    };
  },
  components: {
    SelectPlace,
    SelectStateCity,
  },
  mounted() {},
  methods: {
    changeStateCity(value) {
      console.log(value);
    },
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
</style>
